import type { Template } from "@/types";

export const PO_05_H5_V0: Template[] = [
{
    id: "po-05-h5v0-01",
    name: "PO 01 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 40, y: 230, width: 241, height: 170, rotation: 0, imageRotation: 0 },
            { id: "2", x: 40, y: 408, width: 241, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 289, y: 230, width: 240, height: 170, rotation: 0, imageRotation: 0 },
            { id: "4", x: 289, y: 408, width: 240, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 624, y: 230, width: 489, height: 348, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-02",
    name: "PO 02 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 211, width: 299, height: 211, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 431, width: 299, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 307, y: 211, width: 298, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 307, y: 431, width: 298, height: 210, rotation: 0, imageRotation: 0 },
            { id: "5", x: 613, y: 211, width: 604, height: 430, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-03",
    name: "PO 03 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 211, width: 299, height: 211, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 431, width: 299, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 306, y: 211, width: 603, height: 430, rotation: 0, imageRotation: 0 },
            { id: "4", x: 917, y: 211, width: 300, height: 211, rotation: 0, imageRotation: 0 },
            { id: "5", x: 917, y: 431, width: 300, height: 210, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-04",
    name: "PO 04 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 48, y: 181, width: 514, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 555, width: 167, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 223, y: 555, width: 166, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 397, y: 555, width: 166, height: 116, rotation: 0, imageRotation: 0 },
            { id: "5", x: 657, y: 242, width: 514, height: 366, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-05",
    name: "PO 05 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 210, width: 609, height: 432, rotation: 0, imageRotation: 0 },
        { id: "2", x: 722, y: 87, width: 380, height: 266, rotation: 0, imageRotation: 0 },
        { id: "3", x: 722, y: 361, width: 380, height: 265, rotation: 0, imageRotation: 0 },
        { id: "4", x: 722, y: 635, width: 186, height: 129, rotation: 0, imageRotation: 0 },
        { id: "5", x: 916, y: 635, width: 186, height: 129, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-06",
    name: "PO 06 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 185, y: 149, width: 254, height: 179, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 336, width: 253, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 312, y: 336, width: 253, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 185, y: 525, width: 254, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 657, y: 242, width: 514, height: 366, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-07",
    name: "PO 07 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 141, y: 84, width: 327, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 141, y: 315, width: 327, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 141, y: 546, width: 327, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 676, y: 84, width: 475, height: 338, rotation: 0, imageRotation: 0 },
            { id: "5", x: 676, y: 431, width: 475, height: 337, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-08",
    name: "PO 08 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 37, y: 233, width: 521, height: 367, rotation: 0, imageRotation: 0 },
        { id: "2", x: 707, y: 86, width: 373, height: 259, rotation: 0, imageRotation: 0 },
        { id: "3", x: 707, y: 488, width: 373, height: 259, rotation: 0, imageRotation: 0 },
        { id: "4", x: 707, y: 353, width: 183, height: 126, rotation: 0, imageRotation: 0 },
        { id: "5", x: 898, y: 353, width: 182, height: 126, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-09",
    name: "PO 09 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_09.png",
    size: [1217, 851],
    style: {},
    slots: [   
        { id: "1", x: 69, y: 226, width: 265, height: 196, rotation: 0, imageRotation: 0 },
        { id: "2", x: 69, y: 430, width: 265, height: 195, rotation: 0, imageRotation: 0 },
        { id: "3", x: 342, y: 226, width: 535, height: 399, rotation: 0, imageRotation: 0 },
        { id: "4", x: 885, y: 226, width: 265, height: 196, rotation: 0, imageRotation: 0 },
        { id: "5", x: 885, y: 430, width: 265, height: 195, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-10",
    name: "PO 10 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_10.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 69, y: 125, width: 211, height: 145, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 278, width: 211, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 69, y: 431, width: 211, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 69, y: 583, width: 211, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 288, y: 125, width: 860, height: 602, rotation: 0, imageRotation: 0 }
    ],
}
];